<div class="card bg-white mb-3">
    <div class="d-flex flex-row flex-wrap align-items-center gap-2 p-2 border-bottom">
        <div class="header-title-row">
            <h1 class="h4 mb-0 me-md-3">
                Supplier Contacts
                <span class="badge bg-secondary ms-2" title="Total Companies">{{ getUniqueCompanyCount() }} Companies</span>
            </h1>
            <!-- Mobile overflow actions -->
            <div ngbDropdown placement="bottom-end" class="d-lg-none ms-auto">
                <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle aria-label="Actions">
                    <i class="fas fa-ellipsis-v"></i>
                </button>
                <div ngbDropdownMenu>
                    <h6 class="dropdown-header">Actions</h6>
                    <button *ngIf="user.canManage() && !user.isAnyRestricted()" ngbDropdownItem (click)="createSupplier()">
                        <i class="fas fa-plus me-2 text-muted"></i> Add Supplier
                    </button>
                    <button ngbDropdownItem (click)="downloadSupplierContacts()">
                        <i class="fas fa-download me-2 text-muted"></i> Export Suppliers
                    </button>
                    <button *ngIf="user.canManage() && !user.isAnyRestricted()" ngbDropdownItem (click)="importContacts()">
                        <i class="fas fa-upload me-2 text-muted"></i> Import Contacts
                    </button>
                </div>
            </div>
        </div>
        <div class="contacts-search me-md-3">
            <div class="input-group">
                <span class="input-group-text">
                    <i class="fas fa-search"></i>
                </span>
                <input type="text" class="form-control" placeholder="Search suppliers..." [(ngModel)]="searchTerm"
                    (input)="onSearchChange()">
                @if (searchTerm) {
                <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()" title="Clear search">
                    <i class="fas fa-times"></i>
                </button>
                }
            </div>
        </div>
        <ul ngbNav #contacts="ngbNav" class="nav nav-links flex-wrap ms-md-3">
            <li ngbNavItem>
                <a ngbNavLink (click)="switchTab('active')">Contacts <span class="tab-count">{{ getActiveSupplierCount() }}</span></a>
                <ng-template ngbNavContent>
                    <div class="table-responsive d-none d-lg-block">
                        <table class="table mb-0">
                            <colgroup>
                                <col style="width:56px">
                                <col>
                                <col>
                                <col>
                                <col>
                                <col>
                                <col style="width:70px">
                                <col style="width:70px">
                            </colgroup>
                            <thead class="border-bottom">
                                <tr>
                                    <th></th>
                                    <th class="text-start">Last Name</th>
                                    <th class="text-start">First Name</th>
                                    <th class="text-start">Email</th>
                                    <th class="text-start">Phone</th>
                                    <th class="text-start">Tags</th>
                                    <th class="text-start">Status</th>
                                    <th>
                                        <div class="th"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let group of visibleGroups">
                                    <tr class="supplier-group-header">
                                        <td class="ps-2">
                                            <div class="avatar avatar-32 border bg-white p-1">
                                                <img *ngIf="group.company.logo" [src]="group.company.logo"
                                                    [alt]="group.company.name">
                                                <i *ngIf="!group.company.logo" class="fas fa-building text-muted"></i>
                                            </div>
                                        </td>
                                        <td colspan="6">
                                            <span class="fw-semibold">{{ group.company.name }}</span>
                                            <span class="text-muted small ms-1">({{ group.company.id }})</span>
                                            <span *ngIf="group.users[0].supplierAlias"
                                                class="text-muted small ms-1">({{ group.users[0].supplierAlias }})</span>
                                            <span class="text-muted small ms-2">·
                                                {{ group.users.length }} {{ group.users.length === 1 ? 'contact' : 'contacts' }}</span>
                                        </td>
                                        <td class="text-end pe-2">
                                            <div ngbDropdown class="d-inline-block" placement="bottom-end">
                                                <button type="button" class="btn btn-sm row-actions-btn"
                                                    ngbDropdownToggle>
                                                    <i class="fas fa-ellipsis-v"></i>
                                                </button>
                                                <div ngbDropdownMenu>
                                                    <h6 class="dropdown-header">Company Actions</h6>
                                                    <button ngbDropdownItem class="text-danger"
                                                        (click)="confirmRemoveCompany(group)">
                                                        <i class="fas fa-building me-2"></i> Remove Company
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let supplier of group.users" jft-supplier-table-row
                                        [supplier]="supplier"
                                        (onEditSupplier)="editSupplier($event)"
                                        (onArchive)="archive($event)">
                                    </tr>
                                </ng-container>
                                <tr *ngIf="!groupedSuppliers.length">
                                    <td colspan="8">
                                        <p class="text-center small my-5">No contacts</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="hasMoreGroups" class="text-center my-4">
                            <button class="btn btn-outline-primary px-5 py-2 fw-bold" (click)="loadMore()">
                                Load more companies
                            </button>
                            <p class="text-muted small mt-2">
                                Showing {{ visibleGroups.length }} of {{ groupedSuppliers.length }} companies
                            </p>
                        </div>
                    </div>

                    <!-- Mobile card view (active) -->
                    <div class="d-lg-none supplier-cards p-2">
                        <div class="s-group" *ngFor="let group of visibleGroups">
                            <div class="s-group__head">
                                <div class="avatar avatar-32 border bg-white p-1">
                                    <img *ngIf="group.company.logo" [src]="group.company.logo" [alt]="group.company.name">
                                    <i *ngIf="!group.company.logo" class="fas fa-building text-muted"></i>
                                </div>
                                <div class="s-group__id">
                                    <div class="s-group__name">{{ group.company.name }}</div>
                                    <div class="s-group__meta">
                                        <span *ngIf="group.users[0].supplierAlias">{{ group.users[0].supplierAlias }} · </span>
                                        {{ group.users.length }} {{ group.users.length === 1 ? 'contact' : 'contacts' }}
                                    </div>
                                </div>
                                <div ngbDropdown placement="bottom-end">
                                    <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <h6 class="dropdown-header">Company Actions</h6>
                                        <button ngbDropdownItem class="text-danger" (click)="confirmRemoveCompany(group)">
                                            <i class="fas fa-building me-2"></i> Remove Company
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="s-contact" *ngFor="let supplier of group.users">
                                <div class="s-contact__body">
                                    <div class="s-contact__name">
                                        {{ supplier.firstName }} {{ supplier.lastName }}
                                        <span class="s-status"
                                              [class.s-status--on]="supplier.emailVerified"
                                              [class.s-status--off]="!supplier.emailVerified">
                                            {{ supplier.emailVerified ? 'Active' : 'Pending' }}
                                        </span>
                                    </div>
                                    <a class="s-contact__line" [href]="'mailto:' + supplier.email">{{ supplier.email }}</a>
                                    <div class="s-contact__line" *ngIf="supplier.phone">{{ supplier.phone }}</div>
                                    <div class="s-contact__tags" *ngIf="supplier.tags?.length">
                                        <span *ngFor="let tag of supplier.tags"
                                            class="badge py-1 px-2 me-1 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
                                            {{ tag.name }}
                                        </span>
                                    </div>
                                </div>
                                <div ngbDropdown placement="bottom-end" class="s-contact__actions">
                                    <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <h6 class="dropdown-header">User Actions</h6>
                                        <button ngbDropdownItem (click)="editSupplier(supplier)">
                                            <i class="fas fa-pen me-2 text-muted"></i> Edit Contact
                                        </button>
                                        <div class="dropdown-divider"></div>
                                        <button ngbDropdownItem class="text-danger" (click)="archive(supplier)">
                                            <i class="fas fa-user-minus me-2"></i> Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p *ngIf="!groupedSuppliers.length" class="text-center small my-5 text-muted">No contacts</p>
                        <div *ngIf="hasMoreGroups" class="text-center my-4">
                            <button class="btn btn-outline-primary px-4 py-2 fw-bold" (click)="loadMore()">
                                Load more companies
                            </button>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink (click)="switchTab('archive')">Removed <span class="tab-count">{{ getArchivedSupplierCount() }}</span></a>
                <ng-template ngbNavContent>
                    <div class="table-responsive d-none d-lg-block">
                        <table class="table mb-0">
                            <colgroup>
                                <col style="width:56px">
                                <col>
                                <col>
                                <col>
                                <col>
                                <col>
                                <col style="width:70px">
                                <col style="width:70px">
                            </colgroup>
                            <thead class="border-bottom">
                                <tr>
                                    <th></th>
                                    <th class="text-start">Last Name</th>
                                    <th class="text-start">First Name</th>
                                    <th class="text-start">Email</th>
                                    <th class="text-start">Phone</th>
                                    <th class="text-start">Tags</th>
                                    <th class="text-start">Status</th>
                                    <th>
                                        <div class="th"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let group of visibleGroupsArchived">
                                    <tr class="supplier-group-header">
                                        <td class="ps-2">
                                            <div class="avatar avatar-32 border bg-white p-1">
                                                <img *ngIf="group.company.logo" [src]="group.company.logo"
                                                    [alt]="group.company.name">
                                                <i *ngIf="!group.company.logo" class="fas fa-building text-muted"></i>
                                            </div>
                                        </td>
                                        <td colspan="6">
                                            <span class="fw-semibold">{{ group.company.name }}</span>
                                            <span class="text-muted small ms-1">({{ group.company.id }})</span>
                                            <span *ngIf="group.users[0].supplierAlias"
                                                class="text-muted small ms-1">({{ group.users[0].supplierAlias }})</span>
                                            <span class="text-muted small ms-2">·
                                                {{ group.users.length }} {{ group.users.length === 1 ? 'contact' : 'contacts' }}</span>
                                        </td>
                                        <td class="text-end pe-2">
                                            <div ngbDropdown class="d-inline-block" placement="bottom-end">
                                                <button type="button" class="btn btn-sm row-actions-btn"
                                                    ngbDropdownToggle>
                                                    <i class="fas fa-ellipsis-v"></i>
                                                </button>
                                                <div ngbDropdownMenu>
                                                    <h6 class="dropdown-header">Company Actions</h6>
                                                    <button ngbDropdownItem (click)="unarchiveCompany(group)">
                                                        <i class="fas fa-rotate-left me-2 text-muted"></i> Restore Company
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngFor="let supplier of group.users">
                                        <td></td>
                                        <td>{{supplier.lastName}}</td>
                                        <td>{{supplier.firstName}}</td>
                                        <td>{{supplier.email}}</td>
                                        <td>{{supplier.phone}}</td>
                                        <td>
                                            <span *ngFor="let tag of supplier.tags"
                                                class="badge py-1 px-2 me-1 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
                                                {{ tag.name }}
                                            </span>
                                        </td>
                                        <td>
                                            <i *ngIf="supplier.emailVerified" class="fas fa-user-check" placement="left"
                                                ngbTooltip="Active supplier on JetFuelTenders.com"></i>
                                            <i *ngIf="!supplier.emailVerified" class="fas fa-user-times" placement="left"
                                                ngbTooltip="This user hasn't yet activated their JetFuelTenders.com account"></i>
                                        </td>
                                        <td class="text-end">
                                            <div ngbDropdown class="d-inline-block" placement="bottom-end">
                                                <button type="button" class="btn btn-sm row-actions-btn"
                                                    ngbDropdownToggle>
                                                    <i class="fas fa-ellipsis-v"></i>
                                                </button>
                                                <div ngbDropdownMenu>
                                                    <h6 class="dropdown-header">User Actions</h6>
                                                    <button *ngIf="!supplier.emailVerified" ngbDropdownItem
                                                        (click)="editSupplier(supplier)">
                                                        <i class="fas fa-pen me-2 text-muted"></i> Edit Contact
                                                    </button>
                                                    <button ngbDropdownItem (click)="unarchive(supplier)">
                                                        <i class="fas fa-rotate-left me-2 text-muted"></i> Restore
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr *ngIf="!groupedSuppliersArchived.length">
                                    <td colspan="8">
                                        <p class="text-center small my-5">No removed contacts</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="hasMoreGroupsArchived" class="text-center my-4">
                            <button class="btn btn-outline-primary px-5 py-2 fw-bold" (click)="loadMoreArchived()">
                                Load more companies
                            </button>
                            <p class="text-muted small mt-2">
                                Showing {{ visibleGroupsArchived.length }} of {{ groupedSuppliersArchived.length }} companies
                            </p>
                        </div>
                    </div>

                    <!-- Mobile card view (removed) -->
                    <div class="d-lg-none supplier-cards p-2">
                        <div class="s-group" *ngFor="let group of visibleGroupsArchived">
                            <div class="s-group__head">
                                <div class="avatar avatar-32 border bg-white p-1">
                                    <img *ngIf="group.company.logo" [src]="group.company.logo" [alt]="group.company.name">
                                    <i *ngIf="!group.company.logo" class="fas fa-building text-muted"></i>
                                </div>
                                <div class="s-group__id">
                                    <div class="s-group__name">{{ group.company.name }}</div>
                                    <div class="s-group__meta">
                                        <span *ngIf="group.users[0].supplierAlias">{{ group.users[0].supplierAlias }} · </span>
                                        {{ group.users.length }} {{ group.users.length === 1 ? 'contact' : 'contacts' }}
                                    </div>
                                </div>
                                <div ngbDropdown placement="bottom-end">
                                    <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <h6 class="dropdown-header">Company Actions</h6>
                                        <button ngbDropdownItem (click)="unarchiveCompany(group)">
                                            <i class="fas fa-rotate-left me-2 text-muted"></i> Restore Company
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="s-contact" *ngFor="let supplier of group.users">
                                <div class="s-contact__body">
                                    <div class="s-contact__name">
                                        {{ supplier.firstName }} {{ supplier.lastName }}
                                        <span class="s-status"
                                              [class.s-status--on]="supplier.emailVerified"
                                              [class.s-status--off]="!supplier.emailVerified">
                                            {{ supplier.emailVerified ? 'Active' : 'Pending' }}
                                        </span>
                                    </div>
                                    <a class="s-contact__line" [href]="'mailto:' + supplier.email">{{ supplier.email }}</a>
                                    <div class="s-contact__line" *ngIf="supplier.phone">{{ supplier.phone }}</div>
                                    <div class="s-contact__tags" *ngIf="supplier.tags?.length">
                                        <span *ngFor="let tag of supplier.tags"
                                            class="badge py-1 px-2 me-1 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
                                            {{ tag.name }}
                                        </span>
                                    </div>
                                </div>
                                <div ngbDropdown placement="bottom-end" class="s-contact__actions">
                                    <button type="button" class="btn btn-sm row-actions-btn" ngbDropdownToggle>
                                        <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <h6 class="dropdown-header">User Actions</h6>
                                        <button *ngIf="!supplier.emailVerified" ngbDropdownItem (click)="editSupplier(supplier)">
                                            <i class="fas fa-pen me-2 text-muted"></i> Edit Contact
                                        </button>
                                        <button ngbDropdownItem (click)="unarchive(supplier)">
                                            <i class="fas fa-rotate-left me-2 text-muted"></i> Restore
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p *ngIf="!groupedSuppliersArchived.length" class="text-center small my-5 text-muted">No removed contacts</p>
                        <div *ngIf="hasMoreGroupsArchived" class="text-center my-4">
                            <button class="btn btn-outline-primary px-4 py-2 fw-bold" (click)="loadMoreArchived()">
                                Load more companies
                            </button>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li class="nav-item d-none d-lg-flex align-items-center gap-2 ms-md-auto py-1">
                <button *ngIf="user.canManage() && !user.isAnyRestricted()" (click)="importContacts()"
                    class="btn btn-sm btn-outline-secondary">
                    <i class="fas fa-upload me-1"></i> Import Contacts
                </button>
                <button (click)="downloadSupplierContacts()" class="btn btn-sm btn-outline-secondary">
                    <i class="fas fa-download me-1"></i>Export
                </button>
                <button *ngIf="user.canManage() && !user.isAnyRestricted()" (click)="createSupplier()"
                    class="btn btn-sm btn-primary">
                    <i class="fas fa-plus me-1"></i>Add Supplier
                </button>
            </li>
        </ul>
    </div>
    <div [ngbNavOutlet]="contacts"></div>
</div>
<router-outlet></router-outlet>
